import { Box, Container, Link, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import InstagramIcon from '@mui/icons-material/Instagram';

/**
 * Sjednocena paticka pro verejne stranky (uvodni stranka + live vysledky).
 * Kopie struktury z hasicionline-web.
 */
export const AppFooter = () => {
  const navigate = useNavigate();

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'text.primary',
        color: 'common.white',
        py: 6,
      }}
    >
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={4}
          justifyContent="space-between"
          alignItems={{ xs: 'center', md: 'flex-start' }}
        >
          {/* Sekce 1: Logo + popis */}
          <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              justifyContent={{ xs: 'center', md: 'flex-start' }}
              sx={{ mb: 2 }}
            >
              <Box component="img" src="/img/logo.svg" alt="HasičiOnline logo" sx={{ width: 42, height: 42 }} />
              <Typography variant="h6" component="div" sx={{ fontWeight: 700 }}>
                HasičiOnline.cz Soutěže
              </Typography>
            </Stack>
            <Typography variant="body2" sx={{ opacity: 0.8, maxWidth: 400 }}>
              Živé výsledky hasičských soutěží. Součást platformy HasičiOnline.cz.
            </Typography>
          </Box>

          {/* Sekce 2: Odkazy */}
          <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
            <Typography variant="h6" component="div" gutterBottom sx={{ fontWeight: 600 }}>
              Odkazy
            </Typography>
            <Stack spacing={1}>
              <Link
                component="button"
                onClick={() => navigate('/login')}
                color="inherit"
                underline="hover"
                sx={{ opacity: 0.8, '&:hover': { opacity: 1 }, textAlign: { xs: 'center', md: 'left' } }}
              >
                Přihlášení do administrace
              </Link>
              <Link
                href="https://www.hasicionline.cz"
                target="_blank"
                rel="noopener noreferrer"
                color="inherit"
                underline="hover"
                sx={{ opacity: 0.8, '&:hover': { opacity: 1 } }}
              >
                www.hasicionline.cz
              </Link>
            </Stack>
          </Box>

          {/* Sekce 3: Kontakt */}
          <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
            <Typography variant="h6" component="div" gutterBottom sx={{ fontWeight: 600 }}>
              Kontakt
            </Typography>
            <Stack spacing={1}>
              <Link
                href="mailto:info@lindosoft.cz"
                color="inherit"
                underline="hover"
                sx={{ opacity: 0.8, '&:hover': { opacity: 1 } }}
              >
                info@lindosoft.cz
              </Link>
              <Link
                href="https://www.instagram.com/hasicionline"
                target="_blank"
                rel="noopener noreferrer"
                color="inherit"
                underline="hover"
                sx={{
                  opacity: 0.8,
                  '&:hover': { opacity: 1 },
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 0.5,
                  justifyContent: { xs: 'center', md: 'flex-start' },
                }}
              >
                <InstagramIcon sx={{ fontSize: 18 }} />
                Instagram
              </Link>
            </Stack>
          </Box>

          {/* Sekce 4: Provozovatel */}
          <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
            <Typography variant="h6" component="div" gutterBottom sx={{ fontWeight: 600 }}>
              Provozovatel
            </Typography>
            <Stack spacing={0.5}>
              <Typography variant="body2" sx={{ opacity: 0.8, fontWeight: 600 }}>
                Lindosoft s.r.o.
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.8 }}>
                IČ: 09680195
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.8 }}>
                Čujkovova 1714/21, Zábřeh
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.8 }}>
                700 30 Ostrava
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.8 }}>
                Datová schránka: a4vsc58
              </Typography>
            </Stack>
          </Box>
        </Stack>

        <Box
          sx={{
            borderTop: '1px solid rgba(255, 255, 255, 0.1)',
            mt: 6,
            pt: 4,
            textAlign: 'center',
          }}
        >
          <Typography variant="body2" sx={{ opacity: 0.7 }}>
            © {new Date().getFullYear()} Lindosoft s.r.o. —{' '}
            <Link
              href="https://www.hasicionline.cz"
              target="_blank"
              rel="noopener noreferrer"
              color="inherit"
              underline="hover"
            >
              www.hasicionline.cz
            </Link>
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};
